export default __webpack_public_path__ + "static/media/muhharam_2.d9c9421c.jpg";